// extracted by mini-css-extract-plugin
export default {"optionWrapper":"styles_optionWrapper__PnAtD","iconWrapper":"styles_iconWrapper__Ebuz5"};